<div
  #viewport
  class="bds-scroll-region__viewport"
  [ngClass]="styleClass"
  [attr.aria-label]="ariaLabel"
  [attr.tabindex]="isHorizontalMode || isBothMode ? 0 : null"
  role="region"
>
  <div #content class="bds-scroll-region__content">
    <ng-content></ng-content>
  </div>
</div>

@if (overflowY() && !isHorizontalMode) {
  <div
    class="bds-scroll-region__track"
    aria-hidden="true"
    [class.bds-scroll-region__track--dragging]="dragging()"
    [class.bds-scroll-region__track--active]="scrolling() || dragging()"
  >
    <div
      class="bds-scroll-region__thumb"
      [style.height.px]="thumbHeightPx()"
      [style.transform]="'translateY(' + thumbTopPx() + 'px)'"
      (pointerdown)="onThumbPointerDown($event)"
      (pointermove)="onThumbPointerMove($event)"
      (pointerup)="onThumbPointerUp($event)"
      (pointercancel)="onThumbPointerUp($event)"
    ></div>
  </div>
}

@if (overflowX() && (isHorizontalMode || isBothMode)) {
  <div class="bds-scroll-region__horizontal-track" aria-hidden="true">
    <div
      class="bds-scroll-region__horizontal-thumb"
      [class.bds-scroll-region__horizontal-thumb--dragging]="dragging()"
      [style.width.px]="thumbWidthPx()"
      [style.transform]="'translateX(' + thumbLeftPx() + 'px)'"
      (pointerdown)="onHorizontalThumbPointerDown($event)"
      (pointermove)="onHorizontalThumbPointerMove($event)"
      (pointerup)="onHorizontalThumbPointerUp($event)"
      (pointercancel)="onHorizontalThumbPointerUp($event)"
    ></div>
  </div>
}
